export default "__VITE_ASSET__aZh_D0ib__"